//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import AppItem from './AppList/AppItem';
import PrefixMixin from './PrefixMixin';
import pLimit from 'p-limit';
export default {
  name: 'AppList',
  components: {
    AppItem: AppItem
  },
  mixins: [PrefixMixin],
  props: ['category', 'app', 'search'],
  computed: {
    counter: function counter() {
      return this.apps.filter(function (app) {
        return app.update;
      }).length;
    },
    loading: function loading() {
      return this.$store.getters.loading('list');
    },
    hasPendingUpdate: function hasPendingUpdate() {
      return this.apps.filter(function (app) {
        return app.update;
      }).length > 1;
    },
    showUpdateAll: function showUpdateAll() {
      return this.hasPendingUpdate && ['installed', 'updates'].includes(this.category);
    },
    apps: function apps() {
      var _this = this;

      var apps = this.$store.getters.getAllApps.filter(function (app) {
        return app.name.toLowerCase().search(_this.search.toLowerCase()) !== -1;
      }).sort(function (a, b) {
        var sortStringA = '' + (a.active ? 0 : 1) + (a.update ? 0 : 1) + a.name;
        var sortStringB = '' + (b.active ? 0 : 1) + (b.update ? 0 : 1) + b.name;
        return OC.Util.naturalSortCompare(sortStringA, sortStringB);
      });

      if (this.category === 'installed') {
        return apps.filter(function (app) {
          return app.installed;
        });
      }

      if (this.category === 'enabled') {
        return apps.filter(function (app) {
          return app.active && app.installed;
        });
      }

      if (this.category === 'disabled') {
        return apps.filter(function (app) {
          return !app.active && app.installed;
        });
      }

      if (this.category === 'app-bundles') {
        return apps.filter(function (app) {
          return app.bundles;
        });
      }

      if (this.category === 'updates') {
        return apps.filter(function (app) {
          return app.update;
        });
      }

      if (this.category === 'featured') {
        return apps.filter(function (app) {
          return app.level === 200;
        });
      } // filter app store categories


      return apps.filter(function (app) {
        return app.appstore && app.category !== undefined && (app.category === _this.category || app.category.indexOf(_this.category) > -1);
      });
    },
    bundles: function bundles() {
      var _this2 = this;

      return this.$store.getters.getServerData.bundles.filter(function (bundle) {
        return _this2.bundleApps(bundle.id).length > 0;
      });
    },
    bundleApps: function bundleApps() {
      return function (bundle) {
        return this.$store.getters.getAllApps.filter(function (app) {
          return app.bundleIds !== undefined && app.bundleIds.includes(bundle);
        });
      };
    },
    searchApps: function searchApps() {
      var _this3 = this;

      if (this.search === '') {
        return [];
      }

      return this.$store.getters.getAllApps.filter(function (app) {
        if (app.name.toLowerCase().search(_this3.search.toLowerCase()) !== -1) {
          return !_this3.apps.find(function (_app) {
            return _app.id === app.id;
          });
        }

        return false;
      });
    },
    useAppStoreView: function useAppStoreView() {
      return !this.useListView && !this.useBundleView;
    },
    useListView: function useListView() {
      return this.category === 'installed' || this.category === 'enabled' || this.category === 'disabled' || this.category === 'updates' || this.category === 'featured';
    },
    useBundleView: function useBundleView() {
      return this.category === 'app-bundles';
    },
    allBundlesEnabled: function allBundlesEnabled() {
      var self = this;
      return function (id) {
        return self.bundleApps(id).filter(function (app) {
          return !app.active;
        }).length === 0;
      };
    },
    bundleToggleText: function bundleToggleText() {
      var self = this;
      return function (id) {
        if (self.allBundlesEnabled(id)) {
          return t('settings', 'Disable all');
        }

        return t('settings', 'Enable all');
      };
    }
  },
  methods: {
    toggleBundle: function toggleBundle(id) {
      if (this.allBundlesEnabled(id)) {
        return this.disableBundle(id);
      }

      return this.enableBundle(id);
    },
    enableBundle: function enableBundle(id) {
      var apps = this.bundleApps(id).map(function (app) {
        return app.id;
      });
      this.$store.dispatch('enableApp', {
        appId: apps,
        groups: []
      }).catch(function (error) {
        console.error(error);
        OC.Notification.show(error);
      });
    },
    disableBundle: function disableBundle(id) {
      var apps = this.bundleApps(id).map(function (app) {
        return app.id;
      });
      this.$store.dispatch('disableApp', {
        appId: apps,
        groups: []
      }).catch(function (error) {
        OC.Notification.show(error);
      });
    },
    updateAll: function updateAll() {
      var _this4 = this;

      var limit = pLimit(1);
      this.apps.filter(function (app) {
        return app.update;
      }).map(function (app) {
        return limit(function () {
          return _this4.$store.dispatch('updateApp', {
            appId: app.id
          });
        });
      });
    }
  }
};